const picList = [
  {
    id: 1,
    name:'茂名绿色化工研究院',
    imageUrl: require('../../../assets/images/patentImg/茂名绿色化工研究院.png'),
    link:'http://mmgciri.com/'
  },
  {
    id: 2,
    name:'茂名市工业和信息化局',
    imageUrl: require('../../../assets/images/patentImg/茂名市工业和信息化局.png'),
    link:'http://www.maoming.gov.cn/xxgkml/gxj/'
  },
  {
    id: 3,
    name:'广东石油化工学院',
    imageUrl: require('../../../assets/images/patentImg/广东石油化工学院.png'),
    link:'https://www.gdupt.edu.cn/'
  },
  {
    id: 4,
    name:'茂名市科学技术局',
    imageUrl: require('../../../assets/images/patentImg/茂名市科学技术局.png'),
    link:'http://kjj.maoming.gov.cn/'
  },
  {
    id: 5,
    name:'茂名市农业农村局',
    imageUrl: require('../../../assets/images/patentImg/茂名市农业农村局.png'),
    link:'http://mmny.maoming.gov.cn/'
  },
  {
    id: 6,
    name:'茂名市市场监督管理局',
    imageUrl: require('../../../assets/images/patentImg/茂名市市场监督管理局.png'),
    link:'http://scj.maoming.gov.cn/'
  },
]

module.exports = { picList }
